module.exports = __webpack_public_path__ + "img/comingsoon.a3a7c25c.svg";